import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
//extensionTypes : Extension[]
const ExtensionTypeSelect = ({ extensionTypes, extensionID, handleChange }) => {
	return (
		<>
			<p>Select Extension</p>
			<Select
				labelId='Extension_SelectDropdown'
				id='Extension_SelectDropdown'
				value={extensionID}
				label='ApplicationType'
				onChange={handleChange}
				name='extensionID'
			>
				<MenuItem key='null_extensionType' value={0}>
					none
				</MenuItem>
				{extensionTypes
					?.sort((a, b) =>
						a.description.trim() > b.description.trim() ? 1 : -1
					)
					.map(option => {
						return (
							<MenuItem key={option.fiid} value={option.fiid}>
								{option.description} ({option.fiid})
							</MenuItem>
						);
					})}
			</Select>
		</>
	);
};

export default ExtensionTypeSelect;
